import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DemographicInfo } from 'src/app/people/models/demographicInfo';
import { DialogDirective } from 'src/shared-app-portal/components/dialog/dialog.directive';

@Component({
  selector: 'app-address-warning-dialog',
  templateUrl: './address-warning.dialog.component.html',
  styleUrls: ['./address-warning.dialog.component.scss'],
})
export class AddressWarningDialogComponent {
  @ViewChild('addressWarning', { static: true })
  addressWarning: DialogDirective;
  correctedAddress: DemographicInfo;
  inputAddress: DemographicInfo;
  validationResultMessage: string;
  @Output() useAddress: EventEmitter<DemographicInfo> = new EventEmitter<DemographicInfo>();

  protected onUseAddress(
    clickClose: (input: boolean) => boolean,
    correctedAddress: DemographicInfo
  ): void {
    clickClose(null);
    this.useAddress.emit(correctedAddress);
  }

  public open(
    correctedAddress: DemographicInfo,
    inputAddress: DemographicInfo,
    validationResultMessage: string
  ): Promise<boolean> {
    this.correctedAddress = correctedAddress;
    this.inputAddress = inputAddress;
    this.validationResultMessage = validationResultMessage;

    return this.addressWarning.open({ hideButtonBar: correctedAddress ? true : false });
  }
}
